/**
 * The seed turn a page entry point hands to the chat panel through
 * `window.__NX_CONSULT_SEED`, normalised into one shape the panel can send.
 *
 * A service-page entry point names a service, so it seeds the Service Focus
 * alongside its text and the Consultant's first reply is already about that
 * service. Every other entry point on the site writes a bare string:
 * that is a seed with no Service Focus, which is the normal case and never
 * fabricated into one.
 */

/**
 * @param {unknown} raw            whatever the entry point left on the global
 * @param {string[]} focusIds      the Service Focus ids that exist (NX_SERVICES)
 * @returns {{ text: string, focus: string|null } | null}  null when there is no turn to send
 */
export function readConsultSeed(raw, focusIds) {
  const text = typeof raw === "string" ? raw : typeof raw?.text === "string" ? raw.text : "";
  const trimmed = text.trim();
  if (!trimmed) return null;
  // An id no service answers to is dropped rather than carried: the turn still
  // goes out, just without a Service Focus. The panel drops it where the proxy
  // passes it through because the panel also *renders* the focus — the composer
  // shows the service's title, and an id with no service behind it would put an
  // empty chip above the input.
  const wanted = typeof raw?.focus === "string" ? raw.focus : "";
  return { text: trimmed, focus: focusIds.includes(wanted) ? wanted : null };
}
